export const patch = (self, objectData) => {
  Object.assign(self, objectData)
  Object.assign(self.objectData, objectData)
}
